// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Info: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M6,0 C2.68593764,0 0,2.68593764 0,6 C0,9.31406236 2.68593764,12 6,12 C9.31406236,12 12,9.31406236 12,6 C12,2.68593764 9.31406236,0 6,0 Z M6,3 C6.41414094,3 6.75,3.33585978 6.75,3.75 C6.75,4.16414022 6.41414094,4.5 6,4.5 C5.58585906,4.5 5.25,4.16484404 5.25,3.75 C5.25,3.33515596 5.58515632,3 6,3 Z M6.9375,9 L5.0625,9 C4.75312507,9 4.5,8.74921846 4.5,8.4375 C4.5,8.12578154 4.75195312,7.875 5.0625,7.875 L5.4375,7.875 L5.4375,6.375 L5.25,6.375 C4.93945312,6.375 4.6875,6.12304688 4.6875,5.8125 C4.6875,5.50195312 4.94062507,5.25 5.25,5.25 L6,5.25 C6.31054688,5.25 6.5625,5.50195312 6.5625,5.8125 L6.5625,7.875 L6.9375,7.875 C7.24804688,7.875 7.5,8.12695312 7.5,8.4375 C7.5,8.74804688 7.24921846,9 6.9375,9 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(Info);
